import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { StatisticPaymentDetails } from 'src/features/statistics/types';
import type { ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/statistics/payments/details/';

interface DTO {
    parkingId: string;
    from_date?: string;
    to_date?: string;
    offset?: number;
    limit?: number;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<StatisticPaymentDetails>> => {
    // Custom core filtering
    Object.entries(params).map(([key, value]) => {
        if (Array.isArray(value)) params[key] = params[key].join(',');
    });

    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export {
    RESOURCE as LIST_PAYMENT_DETAILS_STATISTICS_RESOURCE,
    queryFn as listPaymentDetailsStatistics,
    useQueryHook as useListPaymentDetailsStatistics,
};
